/**
 * Client Catalog service.
 * Integrated with backend API
 */

import { apiClient } from './apiClient';

const API_BASE_URL = '/api/v1';

/**
 * Get catalog for a specific client
 */
export const getClientCatalog = async (clientId) => {
  try {
    const response = await apiClient.get(`${API_BASE_URL}/clients/${clientId}/catalog`);
    return response.data?.data || [];
  } catch (error) {
    console.error('Failed to fetch client catalog:', error);
    return [];
  }
};

/**
 * Add products to client's catalog
 */
export const addProductsToClientCatalog = async (clientId, productIds) => {
  try {
    const response = await apiClient.post(`${API_BASE_URL}/clients/${clientId}/catalog`, {
      product_ids: productIds,
    });
    return response.data?.data || [];
  } catch (error) {
    console.error('Failed to add products to catalog:', error);
    throw error;
  }
};

/**
 * Remove a product from client's catalog
 */
export const removeProductFromClientCatalog = async (clientId, productId) => {
  try {
    const response = await apiClient.delete(
      `${API_BASE_URL}/clients/${clientId}/catalog/${productId}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to remove product from catalog:', error);
    throw error;
  }
};

/**
 * Update tear sheet overrides for a catalog line (client-specific P code line).
 */
export const updateClientCatalogTearSheet = async (clientId, productUid, payload) => {
  try {
    const response = await apiClient.patch(
      `${API_BASE_URL}/clients/${clientId}/catalog/${encodeURIComponent(productUid)}/tear-sheet`,
      payload
    );
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Failed to update tear sheet:', error);
    throw error;
  }
};

/**
 * Upload tear sheet documents (product compliance / approved documents) for a buyer catalog line.
 * Links to buyer in DMS; document names include P code prefix.
 */
export const uploadTearSheetDocuments = async (clientId, productUid, category, files) => {
  try {
    const formData = new FormData();
    formData.append('category', category);
    const list = Array.isArray(files) ? files : [];
    list.forEach((file) => {
      formData.append('files[]', file);
    });
    const response = await apiClient.post(
      `${API_BASE_URL}/clients/${encodeURIComponent(clientId)}/catalog/${encodeURIComponent(productUid)}/tear-sheet/documents`,
      formData
    );
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Failed to upload tear sheet documents:', error);
    throw error;
  }
};
